<template>
  <iframe
    :src="`https://academica.etonhouse.com/headless/MedicalInfo/Users/${userId}/Schools/${schoolId}`"
    title="Academica"
    style="width: 100%; min-height: calc(100vh - 110px); zoom: normal; border: 0"
  ></iframe>
</template>

<script>
import { getUsRidSession, getSchoolSession } from '@/helper/util_custom'

export default {
  name: 'AttendanceSubject',
  data() {
    return {
      userId: getUsRidSession(),
      schoolId: getSchoolSession(),
    }
  },
}
</script>
